export default class Ubicaciones {
    constructor($scope,
                $routeParams,
                method,
                ubicacionService,
                tipoEquipoService,
                clientesService,
                proyectosService,
                $location,
                tipoUbicacionesService,
                objetoUbicacionService,
                $uibModal,
                toastr) {
        this.scope = $scope;
        this.scope.filtros = {};
        this.scope.filtros.searchKeyword = "";
        this.location = $location;
        this.toastr = toastr;
        this.modal = $uibModal;
        switch (method) {
            case 'list':
                this.list(ubicacionService);
                break;
            case 'view':
                this.view($routeParams,
                    ubicacionService,
                    tipoUbicacionesService,
                    clientesService,
                    proyectosService,
                    tipoEquipoService,
                    objetoUbicacionService);
                break;
            case 'new':
                this.create(ubicacionService,
                    tipoEquipoService,
                    clientesService,
                    proyectosService,
                    tipoUbicacionesService,
                    objetoUbicacionService);
                break;
        }
    }

    list(ubicacionService) {

        let self = this.scope;
        ubicacionService.getAll().then((resp, err) => {
            self.ubicaciones = resp.data.message;
        });

        self.getItemPage = (item) => {
            let index = self.ubicaciones.indexOf(item);
            let pageNumber = Math.floor(index / 10) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, ubicacionService);
        /*
        this.scope.inAction = false;
        this.scope.eliminar = (id, index) => {
            if(!this.scope.inAction) {
                this.scope.inAction = true;
                ubicacionService.destruct({_id: id}).then((resp) => {
                    this.toastr.success('Ubicación eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
                    .catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al eliminar la ubicacion!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        }*/
    }

    view($routeParams,
         ubicacionService,
         tipoUbicacionesService,
         clientesService,
         proyectosService,
         tipoEquipoService,
         objetoUbicacionService) {

        this.scope.aux = {};
        this.scope.ubicacion = {};

        angular.extend(this.scope, {
            london: {
                lat: -33.4726900,
                lon: -70.6472400,
                zoom: 15
            }
        });

        this.scope.$watch('ubicacion.proyecto', (newVal, oldVal) => {
            if(typeof newVal !== 'undefined') {
                let filter = {
                    proyecto : newVal._id
                }
                objetoUbicacionService.getAll(filter)
                    .then((resp, err) => {
                        this.scope.aux.objeto_ubicaciones = resp.data.message;
                    });
            }
        });

		this.scope.$watch('ubicacion.objeto_ubicacion', (nuevo) => {
            if (typeof nuevo !== 'undefined' && nuevo != null) {

                let filter = {
                    "objeto_ubicacion._id": nuevo._id
                }

                tipoUbicacionesService.getAll(filter)
                    .then((resp) => {
                        this.scope.aux.tipo_ubicaciones = resp.data.message;
                    });
            } else {
                this.scope.aux.tipo_ubicaciones = [];
            }
		});

        clientesService.getAll()
            .then((resp) => {
                this.scope.aux.clientes = resp.data.message;
            });

        proyectosService.getAll()
            .then((resp) => {
                this.scope.aux.proyectos = resp.data.message;
            });

        ubicacionService.getById({id: $routeParams.id}).then((resp, err) => {
            if (!err) {
                this.scope.ubicacion = resp.data.message;
                if (this.scope.ubicacion.tipo.flag_equipos) {
                    tipoEquipoService.getAll()
                        .then((resp) => {

                            this.scope.aux.tipo_equipos = resp.data.message;

                            ubicacionService.getAll({_id: this.scope.ubicacion.padre._id})
                                .then((resp) => {
                                    this.scope.aux.padres = resp.data.message;
                                    this.scope.aux.padres.forEach(padre => {
                                        padre.nombre = padre.nombre + " (" + padre.descripcion + ")";
                                    });
                                });
                        });
                }

                this.scope.aux.tipo_ubicaciones = [this.scope.ubicacion.tipo];

                // tipoUbicacionesService.getAll()
                // 	.then((resp) => {
                // 		this.scope.aux.tipo_ubicaciones = resp.data.message;
                // 	});
            }
        });

        this.scope.agregarTipo = () => {
            this.scope.ubicacion.tipo_equipos.push({
                _id: this.scope.aux.tipo_equipos_aux._id,
                cantidad: this.scope.aux.cantidad_equipos,
                nombre: this.scope.aux.tipo_equipos_aux.nombre,
                disponible: this.scope.aux.cantidad_equipos
            });

            this.scope.aux.cantidad_equipos = undefined;
            this.scope.aux.tipo_equipos_aux = {};
        };

        this.scope.inAction = false;
        this.scope.actualizar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                ubicacionService.update(this.scope.ubicacion).then((resp) => {
                    this.toastr.success('Ubicacion actualizada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/ubicaciones');
                }).catch((err) => {
                    this.scope.inAction = false;
                    this.toastr.error('Error', 'Error al actualizar la ubicacion!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                });
            }
        }

    }

    create(ubicacionService,
           tipoEquipoService,
           clientesService,
           proyectosService,
           tipoUbicacionesService,
           objetoUbicacionService) {

        this.scope.ubicacion = {};
        this.scope.aux = {};

        proyectosService.getAll()
            .then((respPro, err) => {
                this.scope.aux.proyectos = respPro.data.message;
            }).catch((err) => {
            console.log(err);
        });

        this.scope.$watch('ubicacion.proyecto', (newVal, oldVal) => {
            if(typeof newVal !== 'undefined') {
                let filter = {
                    proyecto : newVal._id
                }
                objetoUbicacionService.getAll(filter)
                    .then((resp, err) => {
                        this.scope.aux.objeto_ubicaciones = resp.data.message;
                    });
            }
        });

        /*objetoUbicacionService.getAll()
            .then((resp) => {
                this.scope.aux.objeto_ubicaciones = resp.data.message;
            });*/

        this.scope.$watch('ubicacion.objeto_ubicacion', (newVal, oldVal) => {
            if (typeof newVal !== 'undefined' && newVal != null) {
                let filter = {
                    "objeto_ubicacion._id": newVal._id
                };

                tipoUbicacionesService.getAll(filter)
                    .then((resp) => {
                        this.scope.aux.tipo_ubicaciones = resp.data.message;
                    }).catch((er) => {
                    console.log(er);
                });
            } else {
                this.scope.aux.tipo_ubicaciones = [];
            }
        });

        this.scope.$watch('ubicacion.tipo', (newVal, oldVal) => {
            if (newVal !== undefined) {
                if (newVal.flag_hijo) {
                    let filter = {
                        "tipo.indice": newVal.indice + 1,
                        "objeto_ubicacion._id": newVal.objeto_ubicacion[0]._id
                    };

                    ubicacionService.getAll(filter)
                        .then((resp) => {
                            this.scope.aux.padres = resp.data.message;
                            this.scope.aux.padres.forEach(padre => {
                                padre.nombre = padre.nombre + " (" + padre.descripcion + ")";
                            });
                        }).catch((er) => {
                        console.log(er);
                    });
                }
            }
        });

        let filterTipoEq = {
            "sub_parte": false
        };

        tipoEquipoService.getAll(filterTipoEq)
            .then((resp, err) => {
                this.scope.tipo_equipos = resp.data.message;
            });

        this.scope.agregarTipo = () => {
            this.scope.ubicacion.tipo_equipos.push({
                _id: this.scope.aux.tipo_equipos_aux._id,
                cantidad: this.scope.aux.cantidad,
                nombre: this.scope.aux.tipo_equipos_aux.nombre,
                disponible: this.scope.aux.cantidad
            });
            this.scope.aux.cantidad = undefined;
            this.scope.aux.tipo_equipos_aux = {};
        };

        this.scope.inAction = false;
        this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                let data = this.scope.ubicacion;
                if (data.tipo_equipo) {
                    data.tipo_equipo.flag_disponible = true;
                }

                ubicacionService.save(data)
                    .then((resp, err) => {

                        if (!err) {
                            this.toastr.success('Ubicación agregada correctamente!', 'Success!', {
                                timeOut: 2000,
                                closeButton: true
                            });
                            this.location.path('/ubicaciones');
                        }
                    }).catch((err) => {
                        this.scope.inAction = false;
                        this.toastr.error('Error', 'Error al agregar la ubicacion!', {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }
        };

    }

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Ubicación</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la Ubicación: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 10 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.destruct({_id: object._id}).then((resp) => {
                    self.scope.ubicaciones.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Ubicación eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la Ubicación!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}



// WEBPACK FOOTER //
// ./app/js/controllers/ubicaciones/ubicaciones.js